export default "__VITE_ASSET__DxODhqpj__"